export const enum Approaches {
    RetrieveThenRead = "rtr",
    ReadRetrieveRead = "rrr",
    ReadDecomposeAsk = "rda"
}

export type AskRequestOverrides = {
    semanticRanker?: boolean;
    semanticCaptions?: boolean;
    excludeCategory?: string;
    top?: number;
    modelSelection?: string;
    temperature?: number;
    promptTemplate?: string;
    promptTemplatePrefix?: string;
    promptTemplateSuffix?: string;
    suggestFollowupQuestions?: boolean;
};

export type AskRequest = {
    question: string;
    approach: Approaches;
    overrides?: AskRequestOverrides;
};

export type ratingmodelState = {
    PartitionKey: number,
    flagRating: string,
    anio: number,
    mes: number,
    flagHarmfull: string,
    flagIsNotHelpfull: string,
    flagIsNotTrue: string,
    id: string,
    idConversacion: string,
    messages: messagesRating

}

export type messagesRating = {
    Coment: string,
    date: string,
    hour: string,
    idRespuesta: string,
    preguntaUser: string,
    preguntaUserAnterior: string,
    respuesta: string,
    respuestaAnterior: string

}

export type AskResponse = {
    answer: string;
    thoughts: string | null;
    data_points: string[];
    error?: string;
    id:string;
};

export type ChatTurn = {
    user: string;
    bot?: string;
};



export type ChatRequest = {
    history: ChatTurn[];
    approach: Approaches;
    overrides?: AskRequestOverrides;
};
